import { useFormContext, Controller } from 'react-hook-form';

import useTranslation from 'shared/hooks/useTranslation';

import type { FormState } from '../UserCommonCaseCreateForm.types';

import Stack from '@mui/material/Stack';
import Checkbox from 'shared/components/Checkbox';
import { CheckboxContainer, Label } from '../UserCommonCaseCreateForm.style';

const Instructions = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<FormState>();

  return (
    <Stack spacing={2}>
      <Label>Ohjeet</Label>
      <Stack spacing={3}>
        <CheckboxContainer>
          <Controller
            control={control}
            name="isMasterKeyAllowed"
            render={({ field: { value, onChange } }) => (
              <Checkbox checked={value} onChange={onChange} />
            )}
          />
          <Label>{t('##attribute#incident#uds_masterkeyallowed')}</Label>
        </CheckboxContainer>
        <CheckboxContainer>
          <Controller
            control={control}
            name="isAppartmentHasAdditionalLock"
            render={({ field: { value, onChange } }) => (
              <Checkbox checked={value} onChange={onChange} />
            )}
          />
          <Label>
            {t('##attribute#incident#uds_appartmenthasadditionallock')}
          </Label>
        </CheckboxContainer>
        <CheckboxContainer>
          <Controller
            control={control}
            name="isRepairTimeNeedToBeAgreed"
            render={({ field: { value, onChange } }) => (
              <Checkbox checked={value} onChange={onChange} />
            )}
          />
          <Label>
            {t('##attribute#incident#uds_repairformneedtobeagreed')}
          </Label>
        </CheckboxContainer>
      </Stack>
    </Stack>
  );
};

export default Instructions;
